import { render, staticRenderFns } from "./TableProcedures.vue?vue&type=template&id=c02d198e"
import script from "./TableProcedures.vue?vue&type=script&lang=js"
export * from "./TableProcedures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports